module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "parent",
    on: {
      "dragenter": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "prev", undefined, $event.key)) { return null; }
        _vm.dragover($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5f5e5078"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/draggable/index.vue
// module id = 108
// module chunks = 1